export const ArrowDown = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      width='12'
      height='12'
      viewBox='0 0 12 12'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g id='12px / arrow_dropdown 2'>
        <path id='Subtract' d='M6 9L0 3H12L6 9Z' fill='#37A2BA' />
      </g>
    </svg>
  )
}
